import {AuthToken} from '@github-ui/copilot-auth-token/auth-token'
import {getAgentSessionsTokenProvider} from '@github-ui/copilot-auth-token/agent-sessions-token'

type InitialAuthToken = {token: string; expiration: string; ssoOrgIDs?: string[]}

/**
 * Initializes the auth token from SSR payload if provided.
 */
export function useInitializeAuthToken(initialAuthToken: InitialAuthToken | undefined): void {
  if (!initialAuthToken) return

  const tokenProvider = getAgentSessionsTokenProvider()

  tokenProvider.ssoOrgIDs = initialAuthToken.ssoOrgIDs ?? []

  const existingToken = tokenProvider.getLocalStorageAuthToken()

  const shouldUseSSRToken = !existingToken || existingToken.isExpired || existingToken.value !== initialAuthToken.token

  if (shouldUseSSRToken) {
    const token = new AuthToken(initialAuthToken.token, initialAuthToken.expiration, initialAuthToken.ssoOrgIDs ?? [])
    tokenProvider.setLocalStorageAuthToken(token)
  }
}
